<template>
  <div
    class="order_wrapper"
    :class="{
      native: !$nativeUtil.isDesktop(),
      'filter-loading': filterLoading
    }"
  >
    <!-- 订单详细信息页面 -->
    <van-nav-bar title="订单流水详情" @click-left="$utils.goBack()">
      <template #left>
        <span class="icon-left"></span>
      </template>
    </van-nav-bar>
    <div class="order_box" ref="orderList">
      <!-- 信息列表 -->
      <div class="order_list">
        <div class="order_item">
          <div class="item_label">订单编号</div>
          <div class="item_content">{{ orderObj.orderParkingId }}</div>
        </div>

        <div class="order_item">
          <div class="item_label">车牌号码</div>
          <div class="item_content">{{ orderObj.plateNumber }}</div>
        </div>

        <div class="order_item">
          <div class="item_label">车场名称</div>
          <div class="item_content">{{ orderObj.parkingName }}</div>
        </div>
        <div class="order_item">
          <div class="item_label">岗位名称</div>
          <div class="item_content">{{ orderObj.stationName }}</div>
        </div>

        <div class="order_item">
          <div class="item_label">操作员</div>
          <div class="item_content">{{ orderObj.operator }}</div>
        </div>

        <div class="order_item">
          <div class="item_label">流水状态</div>
          <div class="item_content">
            {{ orderObj.orderFlowStatus | payWayFiler }}
          </div>
        </div>

        <div class="order_item">
          <div class="item_label">支付方式</div>
          <div class="item_content">{{ orderObj.payWay | payWayFiler }}</div>
        </div>

        <div class="order_item">
          <div class="item_label">订单金额</div>
          <div class="item_content">
            <span v-if="orderObj.orderAmount"
              >{{ orderObj.orderAmount }} 元</span
            >
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">应付金额</div>
          <div class="item_content">
            <span v-if="orderObj.payableAmount"
              >{{ orderObj.payableAmount }} 元</span
            >
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">流水金额</div>
          <div class="item_content">
            <span v-if="orderObj.flowAmount">{{ orderObj.flowAmount }} 元</span>
          </div>
        </div>

        <div class="order_item">
          <div class="item_label">支付时间</div>
          <div class="item_content">
            {{ orderObj.createTime | dateFilter_yy_MM_dd_hh_mm_ss }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import { ORDER_PARKING_ORDER_FLOW_PARKING_LIST } from "../../config/config";

export default {
  data: () => ({
    orderObj: {},
    stationId: "",
    filterLoading: false
  }),

  methods: {
    init() {
      this.filterLoading = true;
      this.$utils.getStationId(stationId => {
        this.stationId = stationId;

        this.$utils.changeStatusBarStyle("black");

        let data = this.$route.query;
        console.log(data);
        this.orderObj = data;

        let { orderParkingId } = this.orderObj;

        // 获取岗位Id

        if (orderParkingId) {
          //发起请求，获取订单信息
          this.$request(
            ORDER_PARKING_ORDER_FLOW_PARKING_LIST,
            { orderParkingId, stationId: this.stationId },
            res => {
              this.BScrollInit();
              this.filterLoading = false;
              this.$utils.closeLoading();

              // let data = res["data"];
              console.log(`该订单id为(${orderParkingId}) ===>`, res["data"]);

              //获取信息成功
              // if (this.$condition.isRequestSuccess(res)) {
              // }
            }
          );
        }
      });
    },

    BScrollInit() {
      //加载列表BScroll
      this.$nextTick(() => {
        if (!this.orderListBScroll) {
          this.orderListBScroll = new BScroll(this.$refs.orderList, {
            prototype: 2,
            click: true
          });
        } else {
          this.orderListBScroll.refresh();
        }
      });
    }
  },

  beforeDestroy() {
    if (this.orderListBScroll) {
      this.orderListBScroll.destroy();
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init();
    });
  }
};
</script>

<style lang="less" scoped>
.order_wrapper {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;

  &.native {
    padding-top: 26px;
  }

  .icon-left {
    font-size: 24px;
    margin-right: 6px;
    color: #333;
  }

  .nav_icon {
    font-size: 24px;
  }

  /deep/ .van-nav-bar__title {
    font-size: 20px;
  }
}

.order_box {
  width: 100%;
  height: calc(100% - 46px);
  padding: 0 18px;
  overflow: hidden;

  .order_list {
    width: 100%;
  }
}

.order_item {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  font-size: 20px;
  border-bottom: 1px solid rgba(7, 17, 27, 0.1);

  .item_label {
    flex: 0 0 100px;
    color: #000;
  }

  .item_content {
    flex: 1;
    color: #333;
    position: relative;

    .parkingNumberPop {
      position: absolute;
      left: 0;
      top: -10px;
      z-index: 51;
      background-color: #fff;
      padding: 8px 16px;
      font-size: 24px;
      border: 1px solid rgba(7, 17, 27, 0.1);
    }
  }

  .item_icon {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 28px;
  }
}
</style>
